module.exports = __webpack_public_path__ + "static/flags/MX-275a339898aa681ca9ca5679c80234db.gif";